//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TooltipIcon',
  props: {
    tooltipId: {
      type: String, // must be unique to prevent multiple tooltips appearing on click/hover
      required: true,
    },
    tooltipText: {
      type: String,
      required: true,
    },
    tooltipType: {
      type: String,
      default: 'regular',
      validator(tooltipType) {
        return ['regular', 'deal_banner'].includes(tooltipType);
      },
    },
    position: {
      type: String,
      default: 'bottom',
      validator(pos) {
        return ['top', 'right', 'bottom', 'left'].includes(pos);
      },
    },
  },
};
